module.exports = __webpack_public_path__ + "static/media/pattern-gallery2-sqrTiny.6e28c4c5.png";